import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { Link } from 'react-router-dom'

import { WidgetLayout } from '../../../lib/widget-layout'
import Text from '../../../ui/Text'
import { Table, TableBody, TableBodyCell, TableRow } from '../../../lib/table'
import { Company } from '../../../common/redux/api/companies'
import useText from '../../../common/hooks/useText'

export type SupportPropertiesWidgetProps = {
    className?: ClassName
    style?: React.CSSProperties
    company?: Company
}

export const SupportPropertiesWidget = React.memo(function SupportPropertiesWidget({
    className,
    style,
    company,
}: SupportPropertiesWidgetProps): React.ReactElement {
    const text = useText()
    return (
        <WidgetLayout
            className={cn(className)}
            style={style}
            title={text('lblPropertiesWidget')}
            data-testid="partner-properties-table"
        >
            <Table>
                <TableBody>
                    <TableRow>
                        <TableBodyCell data-testid="partner-name-field">
                            <Text code="lblPartnerField"></Text>
                        </TableBodyCell>
                        <TableBodyCell data-testid="partner-name-link">
                            <Link
                                className="btn btn-link btn-xs"
                                data-testid="table-partner-name"
                                to={`/partner/${company?.partnerId}`}
                            >
                                {company?.partnerName}
                            </Link>
                        </TableBodyCell>
                    </TableRow>
                </TableBody>
            </Table>
        </WidgetLayout>
    )
})
